module.exports = __webpack_public_path__ + "img/icon_logo_foot.deb553db.png";